import React from 'react';
import './edad.css';

const InputEdad = ({ inputNumber, actualizarEdadesMenores, valor }) => {
  return (
    <div className='col-lg-6 container-edad'>
      <select
        className='form-control edad'
        data-indice={inputNumber}
        onChange={actualizarEdadesMenores}
        value={valor}
      >
        <option>-</option>
        {Array.from({ length: 17 }, (_, i) => {
          i++;
          return (
            <option value={i} key={i} data-indice={inputNumber}>
              {i}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default InputEdad;
